import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { JardinComponent } from '../app/components/jardin/jardin.component'
import { LoginComponent } from '../app/components/login/login.component'
import { PersonaComponent } from './components/persona/persona.component'; 
import { AdministradorComponent } from './components/administrador/administrador.component';
import { AuthorizatedGuard } from './guard/authorizated.guard';
import { TutorComponent } from './components/tutor/tutor.component';
import { MegaTutorComponent } from './components/mega-tutor/mega-tutor.component';
import { EquipoPedagogicoComponent } from './components/equipo-pedagogico/equipo-pedagogico.component';
import { AdministradorRegionalComponent } from './components/administrador-regional/administrador-regional.component';

const routes: Routes = [
  { path: "login", component: LoginComponent, pathMatch: "full" },
  { path: "jardin", component: JardinComponent, canActivate: [ AuthorizatedGuard ]},
  { path: "persona", component: PersonaComponent, canActivate: [ AuthorizatedGuard ]}, 
  { path: "administrador", component: AdministradorComponent, canActivate: [ AuthorizatedGuard ]}, 
  { path: "tutor", component: TutorComponent, canActivate: [ AuthorizatedGuard ]}, 
  { path: "mega-tutor", component: MegaTutorComponent, canActivate: [ AuthorizatedGuard ]}, 
  { path: "equipo-pedagogico", component: EquipoPedagogicoComponent, canActivate: [ AuthorizatedGuard ]}, 
  { path: "asesor-tecnico", component: AdministradorRegionalComponent, canActivate: [ AuthorizatedGuard ]}, 
 
  { path: "", component: JardinComponent, canActivate: [ AuthorizatedGuard ]},
  // { path: '', redirectTo: '/home', pathMatch: 'full' },
  // { path: '**', redirectTo: '/home'}
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
